import React, { useEffect, useState } from "react";

import { getAdImageApi } from "../campanhasApi";

/** Imagem do anúncio: a rota exige token, então vem por `fetch` e vira object URL. */
const AdImage: React.FC<{ campaignId: string; adId: string; version: string; alt: string; className?: string }> = ({
  campaignId,
  adId,
  version,
  alt,
  className,
}) => {
  const [src, setSrc] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let url: string | null = null;
    let cancelled = false;
    setFailed(false);
    getAdImageApi(campaignId, adId)
      .then((blob) => {
        if (cancelled) return;
        url = URL.createObjectURL(blob);
        setSrc(url);
      })
      .catch(() => !cancelled && setFailed(true));
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [campaignId, adId, version]);

  if (!src) return <div className={className} role="img" aria-label={failed ? "Imagem indisponível" : "Carregando imagem"} />;
  return <img className={className} src={src} alt={alt} />;
};

export default AdImage;
